import React from 'react'
import { Fragment } from 'react'
import SbEditable from 'storyblok-react'
import { Popover, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import SubmenuItem from './SubmenuItem'
import SubmenuItemImage from './SubmenuItemImage'
import SubmenuCta from './SubmenuCta'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const MenuItemPopup = (item) => {
  return (
    <Popover>
    {({ open }) => (
      <>
        <Popover.Button
          as="div"
          className={classNames(
            open ? 'text-red border-red' : 'text-darkgrey border-transparent',
            'group font-display cursor-pointer pb-4 leading-none inline-flex items-center justify-between text-lg hover:text-red hover:border-red border-b-2 focus:outline-none outline-none duration-300'
          )}
        >
          <span>{item.name}</span>
          <div className="h-5 w-6">
          <ChevronDownIcon
            className={classNames(
              open ? 'text-red' : 'text-darkgrey',
              'ml-2 h-5 w-5 group-hover:text-red duration-300'
            )}
            aria-hidden="true"
          />
          </div>
        </Popover.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 -translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 -translate-y-1"
        >
          <Popover.Panel className="hidden lg:block absolute z-20 top-full inset-x-0 transform shadow-lg bg-white">
            <div className="max-w-[1440px] mx-auto grid gap-y-6 lg:px-16 px-6 py-6 sm:grid-cols-2 sm:gap-8 sm:py-8 lg:grid-cols-4 lg:py-12 xl:py-16">
              {item.submenu.map((item) => (
                <SbEditable content={item} key={item._uid}>
                  {!item.image.filename && <SubmenuItem {...item}/>}
                  {item.image.filename && <SubmenuItemImage {...item}/>}
                </SbEditable>
              ))}
            </div>
            <SubmenuCta {...item}/>
          </Popover.Panel>
        </Transition>
      </>
    )}
    </Popover>
  )
}

export default MenuItemPopup